module.exports = __webpack_public_path__ + "static/img/filmiost.27e2566.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphics/filmiost.png
// module id = nfuD
// module chunks = 0